var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.763604 0.563653C1.11508 0.212181 1.68492 0.212181 2.0364 0.563653L5 3.52726L7.9636 0.563653C8.31508 0.212181 8.88492 0.212181 9.2364 0.563653C9.58787 0.915125 9.58787 1.48497 9.2364 1.83645L5.6364 5.43645C5.28492 5.78792 4.71508 5.78792 4.3636 5.43645L0.763604 1.83645C0.412132 1.48497 0.412132 0.915125 0.763604 0.563653Z",
    fill: "#71717A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandVertical);
export default __webpack_public_path__ + "static/media/ExpandVertical.0085e931de55d4cc6284b03b5dda2c51.svg";
export { ForwardRef as ReactComponent };